import { useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Text,
  Input,
  IconsName,
  allIconsOptions,
  Popover,
} from '@fairfashion/design-system'

import * as Styles from './icon-input.styles'

interface IconInputProps {
  value: string
  onChange: (value: string) => void
  label?: string
  required?: boolean
}

export const IconInput = ({
  value,
  onChange,
  label,
  required,
}: IconInputProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>()
  const [search, setSearch] = useState('')

  const filteredIcons = allIconsOptions.filter((icon) =>
    icon.toLowerCase().includes(search.toLowerCase()),
  )

  return (
    <>
      <Styles.Container direction="column" width="100%">
        {label && (
          <Text size="small" color="grey_2">
            {label} {required && '*'}
          </Text>
        )}
        <Button
          variant="outlined"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          padding="0"
          height="44px"
          width="100%"
        >
          {value ? (
            <Icon name={value as IconsName} size={20} color="grey_1" />
          ) : (
            <Box width="20px" height="20px" />
          )}
        </Button>
      </Styles.Container>

      <Popover
        onClose={() => {
          setAnchorEl(undefined)
          setSearch('')
        }}
        anchorEl={anchorEl}
        position="bottom-start"
      >
        <Box
          padding={3}
          width="500px"
          maxWidth="90vw"
          direction="column"
          gap={2}
        >
          <Input
            placeholder="Pesquisar ícone..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            adornment={<Icon name="search" color="grey_3" />}
          />

          <Box
            direction="row"
            gap={2}
            flexWrap="wrap"
            maxHeight="300px"
            overflow="auto"
            justifyContent="center"
          >
            {filteredIcons.map((iconName) => (
              <Button
                key={iconName}
                variant="text"
                onClick={() => {
                  onChange(iconName)
                  setAnchorEl(undefined)
                  setSearch('')
                }}
                title={iconName}
              >
                <Icon name={iconName as IconsName} size={24} color="grey_1" />
              </Button>
            ))}
          </Box>
        </Box>
      </Popover>
    </>
  )
}
